module.exports = __webpack_public_path__ + "img/3.1fcee20d.jpg";